<span>
  <div>
    <a routerLink="{{shoppingService.routerDestination}}">
      <div *ngIf="shoppingService.order !== null">{{shoppingService.order.type}}: {{shoppingService.order.id}}</div>
      {{shoppingService.item_count}} Items, {{ orderModel.getCurrency(total()*currency_exchange() ,shoppingService) }}
    </a>
  </div>
</span>
